import React, { useRef, useState } from "react";

export const NumpadPinEntry = ({ onComplete }) => {
  const PIN_LENGTH = 6;
  const [pin, setPin] = useState(Array(PIN_LENGTH).fill(""));
  const inputRefs = useRef<Array<React.RefObject<HTMLInputElement>>>(
    [...Array(PIN_LENGTH)].map(() => React.createRef<HTMLInputElement>())
  );

  // Handle actual numpad button click
  const handleNumpadClick = (num) => {
    const idx = pin.findIndex((p) => p === "");
    if (idx === -1) return; // already filled
    updatePin(idx, num);
  };

  // Handle backspace in numpad
  const handleBackspace = () => {
    const idx = pin.slice().reverse().findIndex((p) => p !== "");
    if (idx === -1) return;
    const realIdx = PIN_LENGTH - 1 - idx;
    updatePin(realIdx, "");
    inputRefs.current[realIdx]?.current?.focus();
  };

  // Update pin at index and auto-advance
  const updatePin = (idx, value) => {
    if (idx < 0 || idx >= PIN_LENGTH) return;
    const newPin = [...pin];
    newPin[idx] = value;
    setPin(newPin);
    if (value !== "" && idx < PIN_LENGTH - 1) {
      if (inputRefs.current[idx + 1].current) {
        inputRefs.current[idx + 1].current?.focus();
      }
    }
    if (newPin.every((n) => n !== "")) {
      let result = onComplete?.(newPin.join(""));
      if( result === false) {
        setPin(Array(PIN_LENGTH).fill(""));
        inputRefs.current[0].current?.focus();
      }
    }
  };

  // Handle direct input in input fields (for mobile/desktop fallback)
  const handleInputChange = (idx, e) => {
    const value = e.target.value.replace(/\D/g, "").slice(-1);
    updatePin(idx, value);
  };

  // Optional: handle paste entire PIN
  const handlePaste = (e) => {
    const pasted = e.clipboardData.getData("Text").replace(/\D/g, "").slice(0, PIN_LENGTH);
    if (pasted.length === PIN_LENGTH) {
      setPin(pasted.split(""));
      let result = onComplete?.(pasted);
      if (result === false) {
        setPin(Array(PIN_LENGTH).fill(""));
      }
    }
    e.preventDefault();
  };

  return (
    <div className="container mt-4" style={{ maxWidth: 340 }}>
      <h5 className="mb-3 text-center">Enter 6-digit PIN</h5>
      <div className="d-flex justify-content-center gap-2 mb-3">
        {pin.map((digit, idx) => (
          <input
            key={idx}
            readOnly
            ref={inputRefs.current[idx]}
            type="password"
            className="form-control text-center"
            maxLength={1}
            style={{ width: 40, fontSize: 22 }}
            value={digit}
            inputMode="numeric"
            onChange={(e) => handleInputChange(idx, e)}
            onPaste={handlePaste}
            onFocus={(e) => e.target.select()}
            autoComplete="one-time-code"
          />
        ))}
      </div>
      <div className="row row-cols-3 g-2 justify-content-center">
        {[1,2,3,4,5,6,7,8,9,"",0,"⌫"].map((num, idx) => (
          <div className="col" key={idx}>
            {num === "" ? (
              <div style={{ height: 48 }} />
            ) : num === "⌫" ? (
              <button className="btn btn-secondary w-100" style={{ height: 48 }} onClick={handleBackspace}>
                {num}
              </button>
            ) : (
              <button
                className="btn btn-outline-dark w-100"
                style={{ height: 48 }}
                onClick={() => handleNumpadClick(String(num))}
              >
                {num}
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

